import { render, staticRenderFns } from "./gestao-receituarios.vue?vue&type=template&id=b9b97b3c&scoped=true&"
import script from "./gestao-receituarios.vue?vue&type=script&lang=js&"
export * from "./gestao-receituarios.vue?vue&type=script&lang=js&"
import style0 from "./gestao-receituarios.vue?vue&type=style&index=0&id=b9b97b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b97b3c",
  null
  
)

export default component.exports